import {
    SUPPLIER_FILTER,
    SUPPLIER_TYPE_FILTER,
} from '../constants/ActionTypes';

export const selectSupplier = payload => {
    return {
        type: SUPPLIER_FILTER,
        payload
    }
}

export const selectSupplierType = payload => {
    return {
        type: SUPPLIER_TYPE_FILTER,
        payload
    }
}